/* @flow */
import React, { Component } from 'react'
import { RegularCol, RegularRow } from '../../utils/Grid'
import styled from 'styled-components'
import LinkHandler from '../../utils/LinkHandler'
import Link from '../../utils/Link'
import { type JobsContainerProps } from './Types'

const JobsColumn = styled.ul`
  margin: 10px 0;
  padding-left: 0;
  overflow: hidden;
  max-width: 100%;
  & li::before {
    background: #333;
    border-radius: 6px;
    content: " ";
    display: block;
    height: 4px;
    left: 0;
    position: absolute;
    top: 7px;
    width: 4px;
  }

  & li {
    line-height: 18px;
    list-style: none;
    margin-bottom: 7px;
    padding-left: 13px;
    position: relative;
  }

  & li a {
    color: #333;
    font-size: 13px;
  }
`

export default class JobsContainer extends Component<JobsContainerProps> {
  render () {
    const {
      admon,
      boxes,
      utmParams
    } = this.props

    if (!boxes.length) {
      return null
    }

    return (
      <RegularRow>
        <RegularCol>
          <JobsColumn>
            {
              boxes.map(box => {
                const {
                  guid,
                  link,
                  title
                } = box

                const location = new LinkHandler(link).mergeUTMParams(utmParams).applySASRedirect(admon).link
                return (
                  <li key={guid}>
                    <Link href={location}>
                      { title }
                    </Link>
                  </li>
                )
              })
            }
          </JobsColumn>
        </RegularCol>
      </RegularRow>
    )
  }
}
